export const APP_MESSAGE_CALL = "APP_MESSAGE_CALL";

export function callAppMessage() {
  return { type: APP_MESSAGE_CALL };
}
